import React from "react";
import { URL } from "screen/00_Nav/url";
import { Layout, Row, Col } from "antd";
import LayoutHeader from "screen/00_Nav/layout/layout_header";
import SectionCointaner from "component/sections/section_container";
import TriggerInit from "./trigger/trigger_init";
import DebugHeader from "./component/debug_header";
import DebugAdd from "./component/debug_add";
import DebugTable from "./component/debug_table";
import DialogDebugJob from "./dialog/dialog_debug_add";

//
//component
//redux
//selector
//actions
//utils
//hook
//str

const breadCrum = [
  {
    title: "Home",
    url: null,
  },
  {
    title: "Debug Job",
    url: URL.debugJob,
  },
];

const DebugJobScreen = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row gutter={[10, 20]}>
        <Col xl={18} lg={18} md={18} xs={24}>
          <DebugHeader />
        </Col>
        <Col align="right" xl={6} lg={6} md={6} xs={24}>
          <DebugAdd />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <DebugTable />
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Layout id="bailiff-screen">
      <LayoutHeader title="Virtual Machine Management" />
      <SectionCointaner breadCrum={breadCrum}>
        <div style={{ padding: 24 }}>
          <Row justify={"center"}>
            <Col xl={24} lg={24} md={24} xs={24}>
              {renderBody()}
            </Col>
          </Row>
        </div>
      </SectionCointaner>
      <DialogDebugJob />
      <TriggerInit />
    </Layout>
  );
};
export default DebugJobScreen;
